export default "__VITE_ASSET__BRuyuX85__"